module.exports = __webpack_public_path__ + "img/ic_youtube_default.a446dedc.svg";